import '../assets/css/AboutSection.css'
import Flip from 'react-reveal/Flip';

function AboutSection() {
    return (
        <div className="sec2">
          <div className="aboutSec">
            <h2>About me</h2>
            <p>
                Nice to meet you stranger !<br></br>
                I am Software Engineer. I love Technology and Designs.
            </p>
            <Flip left>
              <a href="/about">
                <button>
                    Show me more
                </button>
              </a>
            </Flip>
            </div>
          </div>
        );
    }
    
export default AboutSection;